// Core imports
import { i18n } from '@/main'
import Vue from 'vue'
import Vuex from 'vuex'
// Modules imports
import auth from './modules/auth'
import customer from './modules/customer'
import records from './modules/records'
import recordsDocuments from './modules/recordsDocuments'
import recordsPeople from './modules/recordsPeople'
import residences from './modules/residences'
Vue.use(Vuex)

// Store initialization
const store = new Vuex.Store({
  modules: {
    auth,
    customer,
    residences,
    records,
    recordsPeople,
    recordsDocuments
  },
  state: {
    language: localStorage.getItem('language') || 'fr'
  },
  mutations: {
    SET_LANGUAGE: (state, language) => (state.language = language)
  },
  actions: {
    setLanguage(store, language) {
      i18n.locale = language
      Vue.config.lang = language
      localStorage.setItem('language', language)
      store.commit('SET_LANGUAGE', language)
    }
  },
  getters: {
    language: state => state.language
  }
})

export default store
